export const selectError = {
	message: (state) => state.error.message,
	page: (state) => state.error.page,
};
